export type ApplicationDeliveryStatus =
  'delivered' | 'pending' | 'checking' | 'manual_review';

export interface ApplicationReceipt {
  submissionId: string;
  receiptToken: string;
  status: ApplicationDeliveryStatus;
  statusUrl: string;
  receivedAt: string;
}

export function createClientSubmissionId(): string {
  const browserCrypto = globalThis.crypto;
  if (typeof browserCrypto?.randomUUID === 'function') {
    return browserCrypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  if (typeof browserCrypto?.getRandomValues === 'function') {
    browserCrypto.getRandomValues(bytes);
  } else {
    // The ID provides retry correlation, not authorization. Receipt access is
    // protected separately by a server-generated HMAC token.
    for (let index = 0; index < bytes.length; index++) {
      bytes[index] = Math.floor(Math.random() * 256);
    }
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0'));
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex
    .slice(6, 8)
    .join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`;
}

export function applicationReceiptMessage(
  status: ApplicationDeliveryStatus,
): string {
  return status === 'delivered'
    ? 'Je sollicitatie is afgeleverd. Wij nemen binnenkort contact met je op.'
    : 'Je sollicitatie is veilig ontvangen en wordt automatisch afgeleverd. Je hoeft niets opnieuw te versturen.';
}
